export const getFormattedDate = (dateString: string): string =>
  new Intl.DateTimeFormat(navigator.language).format(new Date(dateString));
